import { createAction, props } from '@ngrx/store';

import BetslipActions from '../../../base/store/actions';
import { TrackingSlipData } from '../tracking.models';

export default class BetslipTrackingActions {
    static readonly ACTION_SCHEMA = `${BetslipActions.ACTION_SCHEMA}/tracking`;

    private static readonly CHECKOUT = `${BetslipTrackingActions.ACTION_SCHEMA}/CHECKOUT`;

    /**
     * start place bet process (aka checkout shopping cart)
     */
    static checkoutSlip = createAction(BetslipTrackingActions.CHECKOUT, props<{ requestId: string; slips: TrackingSlipData[] }>());
}
